import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const AlignCenterIcon = forwardRef<SVGSVGElement, IconProps>(function AlignCenterIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg ref={ref} width={width} height={height} viewBox="0 0 12 12" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2.7127C2 2.31909 2.25584 2 2.57143 2H9.42857C9.74416 2 10 2.31909 10 2.7127C10 3.10632 9.74416 3.42541 9.42857 3.42541H2.57143C2.25584 3.42541 2 3.10632 2 2.7127ZM4.28571 6C4.28571 5.60639 4.54155 5.2873 4.85714 5.2873H7.14286C7.45845 5.2873 7.71429 5.60639 7.71429 6C7.71429 6.39362 7.45845 6.7127 7.14286 6.7127H4.85714C4.54155 6.7127 4.28571 6.39362 4.28571 6ZM3.14286 9.2873C3.14286 8.89368 3.39869 8.57459 3.71429 8.57459H8.28571C8.60131 8.57459 8.85714 8.89368 8.85714 9.2873C8.85714 9.68091 8.60131 10 8.28571 10H3.71429C3.39869 10 3.14286 9.68091 3.14286 9.2873Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
